var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e30c258da39f8178dbb770d55c4eae7d2cebd181"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["univerplus-student@univation-inc"]={id:"e30c258da39f8178dbb770d55c4eae7d2cebd181"};
      